const moduleoptions = {
	title: "Module Options",
	new_moduleoption: "New Module Option",
	edit_moduleoption: "Edit Module Option: {name}",
	id: "ID",
	moduletemplate_id: "Module Template",
	coursetemplate_id: "Course Template",
	name: "Name",
	price: "Price",
	enrol_select: "Select on enrollment",
	hours: "Hours",
	mandatory_accomplishment: "Mandatory for accomplishment",
	comment: "Comment",
	moduleoption_id: "Module Option",
	enrol_select_disable: "Do not show in enrollment is selected for module. This selection is not available.",
	accomp_select_disable: "Do not show in accomplishment is selected for module. This selection is not available.",
};
export default moduleoptions;